/**
 * 调试面板信令发送模块。
 */
import { useState } from "react";
import { socket } from "@/services/remote/socket";
import { useConnectionStore } from "@/stores/remote";

type SignalMessage = Record<string, unknown>;

/**
 * 手动发送信令消息的调试组件。
 */
export function SignalSection() {
	const { currentRoomId } = useConnectionStore();

	const [candidate, setCandidate] = useState("");
	const [sdp, setSdp] = useState("");
	const sendSignal = (message: SignalMessage) => {
		socket.emit("room-message", {
			room: currentRoomId,
			message,
		});
	};

	return (
		<div className="flex flex-col gap-2 w-full">
			<div className="flex flex-row gap-2">
				<button
					type="button"
					className={`btn btn-sm btn-default ${
						currentRoomId ? "" : "btn-disabled"
					}`}
					onClick={async () => {
						console.log("sent message to room:", currentRoomId);

						socket.emit(
							"room-message",
							{
								room: currentRoomId,
								message: "are you ok",
							},
							(response: unknown) => {
								console.log("got response:", response);
							},
						);
					}}
				>
					Room Message
				</button>

				<button
					type="button"
					className={`btn btn-sm btn-default ${
						currentRoomId ? "" : "btn-disabled"
					}`}
					onClick={async () => {
						sendSignal({ type: "candidate", content: candidate });
					}}
				>
					Send Candidate
				</button>

				<button
					type="button"
					className={`btn btn-sm btn-default ${
						currentRoomId ? "" : "btn-disabled"
					}`}
					onClick={async () => {
						sendSignal({ type: "sdp", content: sdp });
					}}
				>
					Send SDP
				</button>
			</div>

			<div className="flex flex-col gap-2 w-full">
				<label htmlFor="candidate" className="label">
					Candidate
				</label>
				<textarea
					className="textarea textarea-bordered"
					placeholder="Candidate"
					onChange={(e) => {
						setCandidate(e.target.value);
					}}
				></textarea>

				<label htmlFor="sdp" className="label">
					SDP
				</label>
				<textarea
					className="textarea textarea-bordered"
					placeholder="SPD"
					onChange={(e) => {
						setSdp(e.target.value);
					}}
				></textarea>
			</div>
		</div>
	);
}
